import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const ViewInternshipPageLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ViewInternshipPage" */
      './ViewInternshipPage.dynamic'
    ),
  loading: LoadingPageLoadable,
});
